import { render, staticRenderFns } from "./PaySlipComponent.vue?vue&type=template&id=14f7184d&"
import script from "./PaySlipComponent.vue?vue&type=script&lang=js&"
export * from "./PaySlipComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports